import React from 'react';
import { Reveal } from './Reveal';
interface SectionHeadingProps {
  eyebrow?: string;
  children: ReactNode;
  align?: 'center' | 'left';
}
export function SectionHeading({
  children,
  align = 'center'
}: SectionHeadingProps) {
  return <Reveal className={align === 'center' ? 'text-center' : 'text-left'} data-id="element-230">
      <h2 className="font-display text-3xl uppercase leading-tight tracking-tight text-chrome sm:text-4xl lg:text-5xl" data-id="element-231">
        {children}
      </h2>
    </Reveal>;
}